<template>
  <div class="sjzc-dashboard">
    <iframe
      :src="src"
      frameborder="0"
      class="sjzc-dashboard-iframe"></iframe>
  </div>
</template>

<script>
export default {
  name: 'SjzcDashboardPage',
  data() {
    return { src: 'https://dp.clousev.cn/#/release?releaseId=f18d30efb3374df6a000c237034ece61' }
  }
}
</script>
<style lang="stylus" scoped>
.sjzc-dashboard {
  width: 100%
  height: 100%

  .sjzc-dashboard-iframe {
    width: 100%
    height: 100%
  }
}
</style>
